export default "__VITE_ASSET__469aca17__"